import { render, staticRenderFns } from "./PromotionalItemTypes.vue?vue&type=template&id=58d61374&"
import script from "./PromotionalItemTypes.vue?vue&type=script&lang=js&"
export * from "./PromotionalItemTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports